module.exports = __webpack_public_path__ + "static/media/texto_4.dca36416.png";